import { render } from "./Checkbox.vue?vue&type=template&id=ba65760a&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=ba65760a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ba65760a"

export default script